import { Box, FormHelperText } from '@material-ui/core'
import React from 'react'
import { Translate } from 'react-localize-redux'
import PropTypes from 'prop-types'
import Category from './Category'


const CategoriesSelector = ({ input, meta, items }) => {

  const onChange = uuid => checked => {
    if (checked > 0) {
      input.onChange([...input.value, uuid])

      return
    }
    input.onChange(input.value.filter(value => value !== uuid))
  }

  const isInvalid = meta.touched && meta.error

  return (
    <Box>
      <Category depth={1} parentId={null} input={input} items={items} onChange={onChange} />
      {isInvalid && (
        <FormHelperText type="invalid" error>
          {isInvalid ? <Translate id={`joi.error.${meta.error}`} /> : ''}
        </FormHelperText>
      )}
    </Box>
  )
}

CategoriesSelector.defaultProps = {
  items: [],
  input: {
    value: [],
    onChange: () => { },
  },
}

CategoriesSelector.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      parent_id: PropTypes.number,
    })
  ),
}

export default CategoriesSelector
